import React from 'react';
import SlideModal from '@/Atoms/SlideModal';
import useOnboardingSheetStore from '@/Store/onboardingSheetStore';
import {useOnboardingProgress} from '@/Store/onboardingProgressStore';
import ChecklistBody from './ChecklistBody';

interface Props {
  navigationRef?: any;
}

// Global singleton — mounted once in Application.tsx (AlertModal pattern).
// Any surface opens it via useOnboardingSheetStore.getState().openSheet().
//
// This shell is always dismissable. The blocking variant used in School of
// Chess is a separate in-screen overlay (Screens/Books/CsocProfileGate), not a
// mode of this modal, because a screen-covering modal also covers the left menu
// and would strand the user.
export default function OnboardingChecklistSheet({navigationRef}: Props) {
  const {isOpen, source, closeSheet} = useOnboardingSheetStore();
  const {percent} = useOnboardingProgress();

  const go = (route: string) => {
    closeSheet();
    if (route) {
      navigationRef?.navigate?.(route);
    }
  };

  const title =
    source === 'welcome'
      ? "Welcome — let's get you set up"
      : percent >= 100
      ? "You're all set"
      : 'Finish your profile';

  if (!isOpen) {
    return null;
  }

  return (
    <SlideModal
      visible={isOpen}
      type="center"
      showCloseIcon
      onClose={() => closeSheet()}
      modalHeaderTitle={title}>
      <ChecklistBody onNavigate={go} onDismiss={() => closeSheet()} />
    </SlideModal>
  );
}
